<template>
<!--  :style="{ height: height }" -->
  <div class="container">
    <div class="left tab-list">
      <div
        class="tab-item cursor"
        :class="{ active: cur === item.key }"
        v-for="item in tabs"
        :key="'tab-' + item.key"
        @click="change_tab(item.key)"
      >
        <img
          :src="
            cur === item.key
              ? require(`@/assets/images/design/icon-${item.key}-active.png`)
              : require(`@/assets/images/design/icon-${item.key}.png`)
          "
          alt=""
          class="icon"
        />
        <span>{{ item.title }}</span>
      </div>
    </div>
    <div class="center" :style="{ width: width }">
      <Manuscript v-show="cur === 'manuscript'" />

      <Pat v-show="cur === 'pattern'" />

      <Material v-show="cur === 'material'" />

      <Accessory v-show="cur === 'accessory'" />

      <Tech v-show="cur === 'tech'" />

      <Yinhua v-show="cur === 'yinhua'" />

      <Xiuhua v-show="cur === 'xiuhua'" />

      <Trademark v-show="cur === 'trademark'" />

      <Lab v-show="cur === 'label'" />

      <Package v-show="cur === 'package'" />

      <Other v-show="cur === 'other'" />
    </div>

    <div class="footer" v-show="true">
      <div class="btn btn-confirm" @click="onBeforeCheck(0)">Save Design</div>
      <div class="btn btn-draft" v-show="!!uuid" @click="onBeforeCheck(1)">Go to Sample Customization</div>
    </div>

    <chat ref="chat"></chat>
    <img
      class="show-service"
      src="@/assets/images/chat/zxkf.png"
      @click="showChat"
    />
    <!-- 新增浮窗层 -->
    <div
      v-if="is_lesson_popup_show"
      ref="floatingWindow"
      class="floating-window"
    >
      <div class="floating-header">
        <div>Video Tutorial</div>
        <button class="close-btn" @click="hideLessonPopup">&times;</button>
      </div>
      <div class="floating-body">
        <video
          ref="videoplayer"
          src="https://img.hongli.xingjuju.com/yichuanghub/video/lesson.mp4"
          poster="https://img.hongli.xingjuju.com/yichuanghub/video/lesson.mp4?x-oss-process=video/snapshot,t_1000,m_fast"
          class="video"
          controls
          loop
          style="width: 100%; height: 100%"
          @timeupdate="onVideoTimeUpdate"
        >
          Your browser does not support the video tag.
        </video>
      </div>
    </div>

    <!-- 未填提示弹窗 -->
    <popup :show="is_show_empty_part" width="500px" height="350px" @on-close="is_show_empty_part=false">
      <div class="empty-part">
        <div class="title">
          <h1>Tips</h1>
          <div class="desc">
            <p>It has been detected that the following information remains unfilled.</p>
            <p>Would you like to proceed with submission or go back to complete it</p>
          </div>
        </div>
        <div class="list-box">
          <div class="list-item" v-for="(item,index) in tips_list" :key="index">
            <div class="item-label">{{item.label}}</div>
            <div @click.stop="onGoFill(item.label)" :class="['item-value',{'un-fill':item.value,'filled':!item.value}]">{{item.value ? 'Go to supplement' : 'Finished'}}</div>
          </div>
        </div>
        <div class="btn-box">
          <Button @click="save(1)">Continue submitting</Button>
        </div>
      </div>
    </popup>
  </div>
</template>

<script>
  import {
  GetDraft,
  ProductCategoryList,
  Profile,
  SaveDraft,
} from "@/api/index.js";
import axios from 'axios';
import { mapState } from "vuex";

import Chat from "@/components/Chat";
import Popup from '@/components/Popup';
import store from "@/store";
import Accessory from "./components/Accessory";
import Lab from "./components/Label";
import Manuscript from "./components/Manuscript";
import Material from "./components/Material";
import Other from "./components/Other";
import Package from "./components/Package";
import Pat from "./components/Pattern";
import Tech from "./components/Tech";
import Trademark from "./components/Trademark";
import Xiuhua from "./components/Xiuhua";
import Yinhua from "./components/Yinhua";
export default {
  name: "WorkbenchDesign",
  components: {
    Manuscript,
    Pat,
    Material,
    Accessory,
    Chat,
    Tech,
    Yinhua,
    Xiuhua,
    Trademark,
    Lab,
    Package,
    Other,
    Popup
  },
  data() {
    return {
      is_click: false,
      width: "1200px",
      uuid: "",
      cur: "manuscript",
      tabs: [
        { title: "Design Draft", key: "manuscript" },
        { title: "Pattern Selection", key: "pattern" },
        { title: "Material Selection", key: "material" },
        { title: "Accessory Selection", key: "accessory" },
        //{ title: "Process Description", key: "tech" },
        //{ title: "Printing Image", key: "yinhua" },
        //{ title: "Embroidery Image", key: "xiuhua" },
        // {title: "商标图", key: 'trademark'},
        // {title: "吊牌图", key: 'label'},
        // {title: "包装图", key: 'package'},
        //{ title: "Other Files", key: "other" },
        { title: "Video Tutorial", key: "lesson" },
      ],
      is_show_empty_part:false
    };
  },
  watch: {
    // 监听路由参数的变化
    "$route.query.uuid": {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          // 更新数据
          this.uuid = newVal;
        }
      },
      immediate: true, // 立即执行一次handler以初始化数据
      deep: true, // 深度监听（虽然在这个场景下可能不是必需的）
    },
    "$store.state.design.is_lesson_popup_show": {
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.initDraggable();
            // 设置视频播放时间
            const videoPlayer = this.$refs.videoplayer;
            if (videoPlayer) videoPlayer.currentTime = this.videoCurrentTime;
          });
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState({
      form_data: (state) => state.design.form_data,
      height: (state) => state.design.height,
      videoCurrentTime: (state) => state.design.videoCurrentTime,
      is_lesson_popup_show: (state) => state.design.is_lesson_popup_show,
    }),
    tips_list(){
      const {form_data} = this;
      const {accessory_self,accessory,material_self,material,pattern,pattern_id} = form_data;
      const new_material_self = material_self.filter(item => {
        // 获取除了 alias 以外的所有属性值进行判断
        const valuesToCheck = Object.entries(item)
          .filter(([key]) => key !== 'alias')
          .map(([_, val]) => val);
        
        // 判断对象是否非空（只要有一个属性有值就不为空，alias除外）
        return valuesToCheck.some(val => val !== null && val !== undefined && val !== '');
      })
      const new_accessory_self = accessory_self.filter(item => {
        // 判断对象是否非空（只要有一个属性有值就不为空）
        return Object.values(item).some(val => val !== null && val !== undefined && val !== '');
      })
      let arr = [];
      arr.push({label:'Pattern',value:!pattern.length && !pattern_id});
      arr.push({label:'Material',value:!material.length && !new_material_self.length});
      arr.push({label:'Accessory',value:!accessory.length && !new_accessory_self.length})
      return arr;
    },
    must_tips(){
      const {form_data} = this;
      const {accessory_self,accessory,material_self,material,pattern,pattern_id} = form_data;
      const new_material_self = material_self.filter(item => {
        // 获取除了 alias 以外的所有属性值进行判断
        const valuesToCheck = Object.entries(item)
          .filter(([key]) => key !== 'alias')
          .map(([_, val]) => val);
        
        // 判断对象是否非空（只要有一个属性有值就不为空，alias除外）
        return valuesToCheck.some(val => val !== null && val !== undefined && val !== '');
      })
      const new_accessory_self = accessory_self.filter(item => {
        // 判断对象是否非空（只要有一个属性有值就不为空）
        return Object.values(item).some(val => val !== null && val !== undefined && val !== '');
      })
      console.log('material_self',!new_material_self.length);
      console.log('accessory_self',!new_accessory_self.length);
      console.log((!pattern.length && !pattern_id) || (!material.length && !new_material_self.length) || (!accessory.length && !new_accessory_self.length));
      return (!pattern.length && !pattern_id) || (!material.length && !new_material_self.length) || (!accessory.length && !new_accessory_self.length);
    }
  },
  methods: {
    onGoFill(label){
      const type = label.toLowerCase();
      this.change_tab(type);
      this.is_show_empty_part = false;
    },
    hideLessonPopup() {
      // 保存当前视频播放时间
      if (this.$refs.videoplayer) {
        this.$store.commit(
          "design/update_video_current_time",
          this.$refs.videoplayer.currentTime
        );
      }
      this.$store.commit("design/hide_lesson_popup");
    },
    onVideoTimeUpdate() {
      // 更新视频播放时间
      if (this.$refs.videoplayer) {
        this.$store.commit(
          "design/update_video_current_time",
          this.$refs.videoplayer.currentTime
        );
      }
    },
    initDraggable() {
      const win = this.$refs.floatingWindow;
      if (!win) return;

      let isDragging = false;
      let startX, startY;
      let initialX, initialY;

      const startDrag = (e) => {
        isDragging = true;

        const rect = win.getBoundingClientRect();
        initialX = rect.left;
        initialY = rect.top;

        startX = e.pageX;
        startY = e.pageY;

        document.addEventListener("mousemove", onDrag);
        document.addEventListener("mouseup", stopDrag);
      };

      const onDrag = (e) => {
        if (!isDragging) return;

        const dx = e.pageX - startX;
        const dy = e.pageY - startY;

        const newX = initialX + dx;
        const newY = initialY + dy;

        win.style.left = `${newX}px`;
        win.style.top = `${newY}px`;
      };

      const stopDrag = () => {
        isDragging = false;
        document.removeEventListener("mousemove", onDrag);
        document.removeEventListener("mouseup", stopDrag);
      };

      // 清除之前的事件监听器，防止重复绑定
      const header = win.querySelector(".floating-header");
      if (header && !header._dragInitialized) {
        header.addEventListener("mousedown", startDrag);
        header._dragInitialized = true; // 防止重复初始化
      }
    },
    change_tab(cur) {
      if (cur === "lesson") {
        if (["manuscript", "other"].includes(this.cur)) {
          // 不显示浮窗
          return;
        }
        this.$store.commit("design/show_lesson_popup"); // 显示浮窗
      } else if (
        ["manuscript", "trademark", "label", "package", "other"].includes(cur)
      ) {
        this.hideLessonPopup();
        this.$store.commit("design/show_lesson");
        this.cur = cur;
      } else {
        this.$store.commit("design/hide_lesson");
        this.cur = cur;
      }
    },
    showChat() {
      if (!this.uuid) {
        return this.$refs["chat"].showChat();
      }
      let design = {
        uuid: this.uuid,
        image: this.form_data.image,
        name: this.form_data.name,
        from: "draft",
      };
      this.$refs["chat"].showChat(design);
    },
    showChatIcon() {
      this.show = true;
    },
    open_window(path) {
      window.open(path, "_blank");
    },

    onBeforeCheck(redirect){
      if(this.must_tips && redirect){
        this.is_show_empty_part = true;
      }else{
        this.save(redirect);
      }
    },

    cleanEmptyItems(type) {
      // 清理 material_self 中的空数据
      // this.$store.commit("design/update_common", {
      //   key: "material_self",
      //   value: this.form_data.material_self.filter(item => {
      //     // 获取除了 alias 以外的所有属性值进行判断
      //     const valuesToCheck = Object.entries(item)
      //       .filter(([key]) => key !== 'alias')
      //       .map(([_, val]) => val);
          
      //     // 判断对象是否非空（只要有一个属性有值就不为空，alias除外）
      //     return valuesToCheck.some(val => val !== null && val !== undefined && val !== '');
      //   })
      // });
      // 清理 accessory_self 中的空数据
      // this.$store.commit("design/update_common", {
      //   key: "accessory_self",
      //   value: this.form_data.accessory_self.filter(item => {
      //     // 判断对象是否非空（只要有一个属性有值就不为空）
      //     return Object.values(item).some(val => val !== null && val !== undefined && val !== '');
      //   })
      // });
      switch(type){
        case 'material':
          return this.form_data.material_self.filter(item => {
          // 获取除了 alias 以外的所有属性值进行判断
          const valuesToCheck = Object.entries(item)
            .filter(([key]) => key !== 'alias')
            .map(([_, val]) => val);
          
          // 判断对象是否非空（只要有一个属性有值就不为空，alias除外）
          return valuesToCheck.some(val => val !== null && val !== undefined && val !== '');
        });
        case 'accessory':
          return this.form_data.accessory_self.filter(item => {
            // 判断对象是否非空（只要有一个属性有值就不为空）
            return Object.values(item).some(val => val !== null && val !== undefined && val !== '');
          })
      }

      
    },
    async save(redirect) {
      if (this.is_click) {
        return;
      }
      // console.log('form_data',this.form_data);
      if(!this.form_data.product_category_id && !this.form_data.parent_product_category_id){
        this.$layer.msg("Please select product category");
        return;
      }

      if(!this.form_data.image && this.form_data.image_list && !this.form_data.image_list.length){
        this.$layer.msg("Please upload design image/file");
        return;
      }

      const material_self = this.cleanEmptyItems('material');
      const accessory_self = this.cleanEmptyItems('accessory');
      // 数据预处理
      if (material_self.length > 0) {
        this.$store.commit("design/update_common", {
          key: "is_material_self",
          value: 1,
        });
      } else {
        this.$store.commit("design/update_common", {
          key: "is_material_self",
          value: 0,
        });
      }
      if (accessory_self.length > 0) {
        this.$store.commit("design/update_common", {
          key: "is_accessory_self",
          value: 1,
        });
      } else {
        this.$store.commit("design/update_common", {
          key: "is_accessory_self",
          value: 0,
        });
      }

      console.log('this.form_data',this.form_data);
      // return;
      this.is_click = true;
      
      const form_data = {...this.form_data, material_self, accessory_self}
      SaveDraft({
        ...form_data,
        uuid: this.uuid,
        scene: redirect ? "dz" : "bc",
      })
        .then((response) => {
          this.$layer.msg(`Operation successful`);
          if (!redirect && !this.uuid) {
            this.$router.replace({
              name: "WorkBenchDesign",
              query: { uuid: response.data.uuid },
            });
          }
          if (redirect) {
            this.$router.push({
              name: "WorkBenchSummary",
              query: { uuid: response.data.uuid, from: "draft" },
            });
          }
        })
        .catch((res) => {
          this.$layer.msg(res.msg);
        })
        .finally(() => {
          setTimeout(() => {
            this.is_click = false;
          }, 500);
        });
    },
    async getProductCategoryList() {
      return ProductCategoryList().then((response) => {
        this.$store.commit("design/set_product_category_list", response.data);
        return response;
      });
    },
    async getProfile() {
      return Profile().then((response) => {
        return response;
      });
    },
    handleWindowSize(e) {
      console.log("resize", e);
      this.$store.commit(
        "design/set_height",
        window.innerHeight - 90 - 72 + 20 + "px"
      );
      this.width = window.innerWidth - 225 + "px";
    },
  },
  mounted() {
    //防止在点开弹窗以后直接刷新页面导致再次进入弹窗不关闭的问题
    this.hideLessonPopup();
    this.$store.commit("design/show_lesson");
    this.$nextTick(() => {
      this.handleWindowSize();
    });
    window.addEventListener("resize", (e) => {
      this.handleWindowSize(e);
    });
    this.$Spin.show();
    axios.all([
      this.getProductCategoryList(),
      GetDraft({ uuid: this.uuid })
    ]).then(axios.spread((response1, response2) => {
      if(response2.code > 0) {
        return
      }
      this.$store.commit("design/init", { design: response2.data });
    })).finally(() => {
      this.$Spin.hide();
    })
  },
  beforeUnmouont() {
    window.removeEventListener("resize", this.handleWindowSize($event));
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 通过 `vm` 访问组件实例
      store.commit("design/update_video_current_time", 0);
      vm.$emit("showFooter", false);
      vm.$store.commit("design/clear");
    });
  },
  beforeRouteLeave(to, from, next) {
    store.commit("design/update_video_current_time", 0);
    this.$emit("showFooter", true);
    next();
  },
};
</script>

<style lang="scss" scoped>
::v-deep .inner-wrap {
  height: 100%;
  column-gap: 10px;
  ::-webkit-scrollbar {
    display: none;
  }
}

.container {
  display: flex;
  flex-wrap: nowrap;
  border-top: 1px solid #e8e8e8;
  max-height: 100%;
  height: auto;
  width: auto;
  max-width: 1910px;
  min-width: 1200px;
  // overflow:hidden;
  padding-bottom: 80px;
  //   max-width:1920px;
  overflow: visible;
  .left {
    // padding-top: 20px;
    // padding-bottom:80px;
    width: 220px;
    min-width: 220px;
    max-height: 100%;
    overflow-y: auto;
    display: flex;
    justify-content: flex-start;
    align-content: flex-start;
    flex-wrap: wrap;
    border-right: 2px solid #f0f0f0;
    flex-shrink: 0;
    padding: 20px 10px 80px 10px;
    .tab-item {
      margin: 5px 0;
      // width: 150px;
      flex: 1;
      height: 40px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 14px;
      color: #333;
      border-radius: 5px;
      white-space: nowrap;
      .icon {
        width: 26px;
        height: 26px;
        margin: 0 12px 0 18px;
      }
      &.active {
        background: black;
        color: white;
        font-weight: bold;
      }
      &:last-child {
        border-top: 1px solid #f0f0f0;
      }
    }
  }
  .center {
    background: #f8f9fc;
    max-height: 100%;
    min-width: 1180px;
    max-width: 1675px;
    flex-shrink: 0;
  }

  .footer {
    position: fixed;
    height: 60px;
    line-height: 60px;
    left: 0;
    right: 0;
    bottom: 0;
    background: white;
    text-align: center;
    border-top: 1px solid #e2e5e9;
    z-index: 100;
    .btn {
      display: inline-block;
      //width: 140px;
      height: 38px;
      margin: 0 5px;
      line-height: 38px;
      text-align: center;
      font-size: 14px;
      border-radius: 20px;
      cursor: pointer;
      padding: 0 15px;

      &.btn-draft {
        background: #ebebeb;
        color: #1c1f23;
      }

      &.btn-confirm {
        background: #1c1f23;
        color: white;
      }
    }
  }

  .show-service {
    position: fixed;
    top: 200px;
    width: 80px;
    height: 30px;
    right: 0;
  }
}

@media (min-width: 1280px) and (max-width: 1679px) {
  .container {
    overflow: visible;
  }
}

@media (max-width: 1279px) {
  .container {
    overflow: visible;
  }
}

.floating-window {
  position: fixed;
  bottom: 10px;
  right: 10px;
  width: 640px;
  max-width: 90vw;
  height: 420px; // 固定高度避免变形
  // min-height:200px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  z-index: 9999;
  user-select: none;
}

.floating-header {
  padding: 5px 15px;
  background: #f0f0f0;
  border-bottom: 1px solid #ddd;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: move;
  font-weight: bold;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.floating-body {
  padding: 10px;
  height: calc(100% - 40px); // 标题栏占 40px
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
}

.close-btn {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
}

.empty-part{
  background:#ffffff;
  width:100%;
  .title{
    text-align:center;
    color:#000000;
    .desc{
      width:100%;
      text-align: center;
      font-size:14px;
      color:#333333;
    }
  }
  .list-box{
    padding:0 20px;
    margin-top:20px;
    display:flex;
    flex-direction:column;
    row-gap:10px;
    .list-item{
      display:flex;
      align-items:center;
      justify-content:space-between;
      background:#e7e7e7;
      border-radius:10px;
      padding:10px;
      .item-label{
        color:#000000;
        font-size:16px;
      }
      .item-value{
        color:#333333;
        font-size:14px;
        cursor:pointer;
        &.un-fill{
          color:red;
        }
        &.filled{
          color:green;
        }
      }
    }
  }
  .btn-box{
    width:100%;
    display:flex;
    justify-content:center;
    margin-top:20px;
    Button{
      width:160px;
      height:50px;
      background:#1c1f23;
      color:#ffffff;
      border-radius:30px;
    }
  }
}
</style>
